<form [formGroup]="form" (ngSubmit)="accept()" novalidate>
    <div class="modal-header">
        <h4 class="modal-title">Detalle Opcion</h4>
        <button type="button" class="close" aria-label="Close" (click)="dismiss()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>

    <div class="modal-body">
        <div class="row">
            <div class="form-group col-md-12">
                <label for="opcion">Opción</label>
                <input type="text" class="form-control" id="opcion" formControlName="opcion"
                    [ngClass]="{ 'is-invalid': submitted && form.controls.opcion.errors }">
                <div *ngIf="submitted && form.controls.opcion.errors" class="invalid-feedback">
                    <div *ngIf="form.controls.opcion.errors.required">Campo requerido</div>
                </div>
            </div>

            <div class="form-group col-md-12">
                <label for="descripcion">Descripción</label>
                <textarea rows="5" class="form-control" id="descripcion" formControlName="descripcion"
                    [ngClass]="{ 'is-invalid': submitted && form.controls.descripcion.errors }">
                </textarea>
                <div *ngIf="submitted && form.controls.descripcion.errors" class="invalid-feedback">
                    <div *ngIf="form.controls.descripcion.errors.required">Campo requerido</div>
                </div>
            </div>

            <div class="modal-footer full-width col-md-12">
                <div class="col-md-12 text-center">
                    <button type="button" class="btn btn-danger btn-fidelis col-md-4" (click)="dismiss()">
                        <i class="fa fa-times-circle"></i>
                        Cancelar
                    </button>
                    <button type="submit" class="btn btn-success btn-fidelis col-md-4">
                        <i class="fa fa-check-circle"></i>
                        Aceptar
                    </button>
                </div>
            </div>
        </div>
    </div>
</form>